import { render, staticRenderFns } from "./ShowOutsourcing.vue?vue&type=template&id=61dd14d0&scoped=true&"
import script from "./ShowOutsourcing.vue?vue&type=script&lang=js&"
export * from "./ShowOutsourcing.vue?vue&type=script&lang=js&"
import style0 from "./ShowOutsourcing.vue?vue&type=style&index=0&id=61dd14d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd14d0",
  null
  
)

export default component.exports